import {
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';
import {
  KissanEventType,
  useEventZStore,
  useProfileStore
} from '@ninjacart/nc-nk-store';
import { Paragraph, Stack, View, XStack, useTheme } from '@ninjacart/nc-nk-ui';
import { Search } from '@tamagui/lucide-icons';
import { t } from 'i18next';
import { useRef } from 'react';
import { Animated, Pressable } from 'react-native';
import { useRouter } from 'solito/navigation';

export const AnimatedDiscoverHeader = ({
  // animatedValue,
  // opacity,
  // height,
}: {
  // animatedValue: AnimatableNumericValue;
  // opacity: AnimatableNumericValue;
  // height: number;
}) => {
  const userProfile = useProfileStore((state) => state.userProfile);
  const { push } = useRouter();
  const theme = useTheme();
  const globalSearchEnabled = useEventZStore((state) => state.globalSearchEnabled);
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const handleSearch = () => {
    push('/search');

    const disSearchClickEvent :INinjaEvent = {
      name: KissanEventType.DIS_SEARCH_CLICK,
      screenDetails: { screen: 'discovery page' }
    };
    enqueue(disSearchClickEvent);
  };

  return (
    <Animated.View
      style={{
        flexDirection: 'row',
        justifyContent: 'space-around',
        width: '100%',
        height: 50,
        left: 0,
        right: 0,
        // transform: [{ translateY: animatedValue }],
        position: 'absolute',
        // opacity: opacity,
        // elevation: 4,
        zIndex: 1,
      }}
    >
      <View
        width={'100%'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        backgroundColor={'$background'}
        paddingBottom={10}
        paddingHorizontal={12}
      >
        <XStack>
          <Paragraph fontSize={21} fontWeight={'600'} color={'$color'} paddingTop={10}>
            {t('page.watch')}
          </Paragraph>
        </XStack>
        <XStack>
          {globalSearchEnabled && (
            <Pressable onPress={handleSearch}>
              <Stack
                borderRadius={50}
                borderWidth={1}
                borderColor={'$primary'}
                backgroundColor={'$background'}
                padding={8}
                testID='kisan_tId_discover_search_button'
              >
                <Search color={theme['primary']?.val} size={22} />
              </Stack>
            </Pressable>
          )}

          {/* <Stack
                        borderRadius={50}
                        borderWidth={1}
                        borderColor={'rgba(115, 115, 115, 0.40)'}
                        backgroundColor={'$background'}
                        padding={8}
                    >
                        <Bell color={'#368665'} size={22} />
                    </Stack> */}
        </XStack>
      </View>
    </Animated.View>
  );
};
